import { SUB_COLLECTIONS } from '../constants';
import FirebaseUsage from "../firebase.usage";
import {COLLECTIONS} from "../constants";
import ProjectModel, {ProjectUploadModel} from "../../models/responses/project.model";
import {DefaultSubscribeCallback} from "../../store/middleware/middlewares";
import { decompressFromBase64 } from 'lz-string'
import {CalendarModel} from "../../models/responses/calendar.model";
import { ClientDocModel } from '../../models/responses/client.model';
import {SprintDataModel} from "../../models/sprint.model";
import {subsManager} from "../../store/middleware/subs-manager/subs-manager";
import {ContractModel} from "../../models/contract.model";

export class ProjectSubscriptions {
    static async projectUpdates(callback: DefaultSubscribeCallback<ProjectModel[]>) {
        const client =  await FirebaseUsage.getQuery(COLLECTIONS.CLIENTS, ["domain", "==", window.location.hostname]).
        then((snapshot) => {
            if (snapshot.docs.length) {
                return snapshot.docs[0] ? snapshot.docs[0].data() as ClientDocModel : null;
            }
        })

        const hostname = window.location.hostname;

        if (!client && hostname !== 'localhost') {
            return;
        }

        const conditions = hostname === 'localhost' ?
            [['archived', '==', false]] :
                [['clientId', '==', client?.clientId]]

        return FirebaseUsage.queryListener(COLLECTIONS.PROJECTS, conditions,
            async (data: any) => {
                let changedProjects: ProjectModel[] = []
                data.docChanges().forEach((change: any) => {
                    if (change.type === 'modified') {
                        console.log("Project modified: ", change.doc.id);
                        const projectDoc = change.doc.data() as ProjectModel;
                        changedProjects.push({...projectDoc, projectId: change.doc.id} as ProjectModel)
                    }})

                callback(changedProjects)
        });
    }

    static async projectList(userId: string | null, callback: DefaultSubscribeCallback<ProjectModel[]>, clientCallback: any) {
      const client =  await FirebaseUsage.getQuery(COLLECTIONS.CLIENTS, ["domain", "==", window.location.hostname]).
        then((snapshot) => {
            if (snapshot.docs.length) {
              return snapshot.docs[0] ? snapshot.docs[0].data() as ClientDocModel : null;
            }
          })

        clientCallback(client ? client.clientId : null)

        const conditions = window.location.hostname === 'localhost' ?
            [['availableToDev', '==', true]] :
            client && client.specificContractId ?
            [['contractId', '==', client.specificContractId]] :
            [['clientId', '==', client?.clientId]]

        return FirebaseUsage.queryListener(COLLECTIONS.CONTRACTS, conditions,
            async (data: any) => {
                const contracts = data.docs.map((doc: any) => doc.data() as ContractModel);
                let projectData = await Promise.all(contracts.map( async (contract: any) => {
                    if (!contract.lastUploadProjectId) {
                        return null;
                    }
                    const projectDoc = await FirebaseUsage.getDoc(COLLECTIONS.PROJECTS, contract.lastUploadProjectId)
                        .then((doc) => ({...doc.data(), projectId: doc.id}) as ProjectModel);
                    // @ts-ignore
                    if(projectDoc.isUpdate){
                        return null;
                    }
                    if (!projectDoc.grade) {
                        return null;
                    } else if (!projectDoc.grade[userId!]) {

                        return null;
                    }
                    if (!projectDoc.contractId) {
                        return null;
                    }
                    if (contract.archived) {
                        projectDoc.retired = true;
                    }

                    projectDoc.contractName = contract.contractName


                    let calendarsArr:any[] = [];
                    let debugDataStr = "";
                    let debugDataArr:any[] = []
                    let curvesStr = "";
                    let curvesArr:any[] = []
                    let calendarDocs = await FirebaseUsage.getSubCollection(COLLECTIONS.PROJECTS, projectDoc.projectId, SUB_COLLECTIONS.CALENDARS);

                    calendarDocs.docs.map((doc) => {
                        calendarsArr.push(doc.data());
                        return null;
                    })
                    calendarsArr.sort((a,b) => a.order - b.order)
                    let calArray = calendarsArr.map( el => {
                        const calData = JSON.parse(el.calendars)
                        let calMap: Map<string, any> | null = null
                        if (calData.workday_exceptions) {
                            calMap = new Map()
                            calData.workday_exceptions.forEach((exception: any) => {
                                calMap?.set(exception.date, exception)
                            })
                        }
                        return {
                            ...calData, exceptionsArr: calMap
                        }
                    })

                    let calendarDict = {}
                    const getCalendars = await FirebaseUsage.getQuery(COLLECTIONS.CALENDAR, ['project_id', '==', projectDoc.projectId])
                    .then(data => data.docs.map(el => ({...el.data() as CalendarModel, id: el.id})))
                    for (const cal of getCalendars) {
                        calendarDict[cal.calendar_id] = cal.id
                    }

                    debugDataArr.sort((a,b) => a.order - b.order)
                    for (const el of debugDataArr) {
                        debugDataStr =  debugDataStr.concat( el.debugdata)
                    }

                let curvesDocs =  await FirebaseUsage.getSubCollection(COLLECTIONS.PROJECTS, projectDoc.projectId, SUB_COLLECTIONS.CURVES);

                    curvesDocs.docs.map((doc) => {
                        curvesArr.push(doc.data());
                        return null
                    });

                curvesArr.sort((a,b) => a.order - b.order)
                for (const el of curvesArr) {
                    curvesStr =  curvesStr.concat( el.curves)
                }
                    const racingLine = projectDoc.racingLine;
                    const curves = decompressFromBase64(curvesStr);
                    return {
                        ...projectDoc,
                        projectId: projectDoc.projectId,
                        issueCategories: projectDoc.issueCategories ? projectDoc.issueCategories : [
                            {reason: 'Directive', text: 'Directive'},
                            {reason: 'Incident', text: 'Incident'},
                            {reason: 'Information', text: 'Information'},
                            {reason: 'Resource', text: 'Resource'},
                            {reason: 'Other', text: 'Other'},
                        ],
                        curves: curves ? JSON.parse(curves) : {
                            early: [],
                            late: [],
                            expected: [],
                            actual: [],
                        },
                        // @ts-ignore
                        racingLine: typeof racingLine === 'string' ? JSON.parse(projectDoc.racingLine) : racingLine,
                        calendars: calArray,
                        calendarDict:calendarDict,
                    } as ProjectModel
                }))
                    let projectDataFilter = projectData.filter( e => e !== null) as Array<ProjectModel>;
                callback(projectDataFilter)
        });
    }

    static async trackedMilestones(projectId: string, callback: any) {
        return FirebaseUsage.getQuery(COLLECTIONS.TRACKED_MILESTONES, ['projectId', '==', projectId]).then(data => {
            callback(data.docs.map(doc => doc.data()))
        })
    }

    static async checklists(clientId: string, callback: any) {
        return FirebaseUsage.getQuery(COLLECTIONS.CHECKLISTS, ['clientId', '==', clientId]).then(data => {
            callback(data.docs.map(doc => doc.data()))
        })
    }

    static getGeoData(projectId: string, callback: any) {
        return FirebaseUsage.queryListener(COLLECTIONS.GEO_DATA, [['projectId', '==', projectId]], (data: any) => {
            callback(data.docs.map((doc: any) => doc.data()))
        })
    }

    static getProjectRisks(contractId: string, callback: any) {
        return FirebaseUsage.queryListener(COLLECTIONS.RISKS, [['contractId', '==', contractId]], (data: any) => {
            callback(data.docs.map((doc: any) => doc.data()))
        })
    }

    static riskUpload(riskUploadId: string, callback: any) {
        return FirebaseUsage.documentListener(COLLECTIONS.RISK_UPLOADS, riskUploadId, (data: any) => {
            callback(data.data())
        })
    }

    static async getDataVersions(contractId: string, callback: any) {
        return FirebaseUsage.getQuery(COLLECTIONS.DATA_VERSIONS, ['contractsUpdated', 'array-contains', contractId])
            .then(data => callback(data.docs.map(doc => doc.data())))
    }

    static async getSprintData(contractId: string, callback: any) {
        return FirebaseUsage.getQuery(COLLECTIONS.SPRINT_DATA, ['contractId', '==', contractId])
            .then(data => callback(data.docs.map(doc => doc.data() as SprintDataModel)))
    }

    static async projectUploads(userId: string, callback: any) {
        return FirebaseUsage.queryListener(COLLECTIONS.PROJECT_UPLOADS, [
            ['userId', '==', userId],
            ['status', '!=', 'complete']
        ], (data: any) => {
            const changes = data.docChanges()
            changes.forEach((change: any) => {
                if (change.type === 'removed') {
                    subsManager.subscribeProjectPermission(userId)
                }
            })
            callback(
                data.docs.map((doc: any) => doc.data() as ProjectUploadModel)
                    .filter((el: ProjectUploadModel) => el.status !== 'deleted')
            )
        })
    }

    static async projectVersions(contractId: string, projectId: string, callback: any) {
        let projectVersionArray: any[] = []
        const versionIdMap: Map<string, boolean> = new Map<string, boolean>();

        const projects = await FirebaseUsage.getQuery(COLLECTIONS.PROJECTS, ['contractId', '==', contractId])
            .then(data => data.docs.map(doc => ({
                ...doc.data(),
                projectId: doc.id
            }) as ProjectModel));

        projects.forEach(project => {
            if (project && !versionIdMap.has(project.projectId)) {
                versionIdMap.set(project.projectId, true);
                projectVersionArray.push({
                    id: project.projectId,
                    projectId: project.projectId,
                    dataVersionId: null,
                    versionName: project.name,
                    versionTimestamp: project.updateDate!
                })
            }
        });

        const dataVersions = await FirebaseUsage.getQuery(COLLECTIONS.SPRINT_DATA, ['contractId', '==', contractId])
            .then(data => data.docs.map(doc => doc.data() as SprintDataModel));

        dataVersions.forEach(dataVersion => {
            if (dataVersion && !versionIdMap.has(dataVersion.dataVersionId)) {
                versionIdMap.set(dataVersion.dataVersionId, true);
                projectVersionArray.push({
                    id: dataVersion.dataVersionId,
                    projectId: null,
                    dataVersionId: dataVersion.dataVersionId,
                    versionName: 'sprint',
                    versionTimestamp: dataVersion.periodStart
                })
            }
        });

        projectVersionArray.push({
            id: 'current',
            projectId: null,
            dataVersionId: 'current',
            versionName: 'current',
            versionTimestamp: FirebaseUsage.timestamp()
        })


        callback(projectVersionArray);
    }
}
